/**
 * 表单验证
 */
function validateFormHandler() {

  /**
   * 手机验证
   */
  this.validatorPhone = function (rule, value, callback) {
    let phoneReg = /^1[3-578]\d{9}$/;
    if (phoneReg.test(value)) {
      callback();
    } else {
      callback(new Error(rule.message));
    }
  };
  /**
   * 验证邮箱
   */
  this.validateEmail = function (rule, value, callback) {
    let mailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    if (mailReg.test(value)) {
      callback();
    } else {
      callback(new Error(rule.message));
    }
  }
  /**
   * 验证数组
   * @param {*} rule 
   * @param {*} value 
   * @param {*} callback 
   */
  this.validatorPrice = function (rule, value, callback) {
    let re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/ 
    if (re.test(value)) {
      callback();
    } else {
      callback(new Error(rule.message));
    }
  }
  /**
   * 验证折扣
   */
  this.validateZhekou = function (rule, value, callback) {
    if (value > 0 && value <= 1) {
      callback();
    } else
      callback(new Error(rule.message));
  }
}

validateFormHandler.prototype.addAdminUserFormDataValidateRuls = function () {
  return {
    username: [{
      required: true,
      message: "请输入姓名",
      trigger: "blur"
    }],
    category: [{
      required: true,
      message: "请选择账户类型",
      trigger: "blur"
    }],
    account: [{
      required: true,
      message: "请输入登录账号",
      trigger: "blur"
    }],
    password: [{
      required: true,
      message: "请输入登录密码",
      trigger: "blur"
    }]
  }
}

validateFormHandler.prototype.projectModularFormDataValidateRuls = function () {
  return {
    modulename: [{
      required: true,
      message: "请输入模块名称",
      trigger: "blur"
    }]
  }
}

validateFormHandler.prototype.projectModularConditionFormDataValidateRuls = function () {
  return {
    conditionname: [{
      required: true,
      message: "请输入评分项名称",
      trigger: "blur"
    }],
    remark: [{
      required: true,
      message: "请输入评分项描述",
      trigger: "blur"
    }],
    conditionscorebasic: [{
      required: true,
      message: "评分项标准分值",
      trigger: "blur"
    }]
  }
}
validateFormHandler.prototype.ntelligentRequestionDataValidateRuls = function () {
  return {
    title: [{
      required: true,
      message: "请输入标题",
      trigger: "blur"
    }],
    keywords: [{
      required: true,
      message: "请输入关键词",
      trigger: "blur"
    }],
    sort: [{
      required: true,
      message: "请输入排序",
      trigger: "blur"
    }]
  }
}
validateFormHandler.prototype.ptJobFormDataValidateRuls = function () {
  return {
    ptjobname: [{
      required: true,
      message: "请输职位名称",
      trigger: "blur"
    }],
    companyname: [{
      required: true,
      message: "请输入公司名称",
      trigger: "blur"
    }],
    companyremark: [{
      required: true,
      message: "请输入公司介绍",
      trigger: "blur"
    }],
    ptjobdescription: [{
      required: true,
      message: "请输入职位介绍",
      trigger: "blur"
    }],
    jobrequirements: [{
      required: true,
      message: "请输入任职要求",
      trigger: "blur"
    }],
    Jobresponsibilities: [{
      required: true,
      message: "请输入岗位职责",
      trigger: "blur"
    }],
    salary: [{
      required: true,
      message: "请输入薪资待遇",
      trigger: "blur"
    }],
    address: [{
      required: true,
      message: "请输入任职地点",
      trigger: "blur"
    }]
  }
}

validateFormHandler.prototype.runnerOtherFormDataValidateRuls = function () {
  return {
    name: [{
      required: true,
      message: "请输入特殊需求名称",
      trigger: "blur"
    }],
    value: [{
      required: true,
      message: "请输入费用",
      trigger: "blur"
    }]
  }
}

/**
 * 员工信息表单验证规则
 */
validateFormHandler.prototype.personFormDataValidateRuls = function () {
  return {
    username: [{
      required: true,
      message: "请输入姓名",
      trigger: "blur"
    }],
    position: [{
      required: true,
      message: "请输入职位",
      trigger: "blur"
    }],
    password: [{
      required: true,
      message: "请输入初始密码",
      trigger: "blur"
    }],
    departid: [{
      required: true,
      message: "请选择部门",
      trigger: "blur"
    }],
    usercode: [{
      required: true,
      message: "请输入工号",
      trigger: "blur"
    }],
    phone: [{
      required: true,
      validator: this.validatorPhone,
      message: "请输入正确的电话号码",
      trigger: "blur"
    }],
    email: [{
      required: true,
      validator: this.validateEmail,
      message: "请输入邮箱",
      trigger: "blur"
    }],
    entrydate: [{
      required: true,
      message: "请选择入职时间",
      trigger: "blur"
    }],
    emergencycontact: [{
      required: true,
      message: "请输入紧急联系人",
      trigger: "blur"
    }],
    emergencycontactphone: [{
      required: true,
      validator: this.validatorPhone,
      message: "请输入紧急联系人电话",
      trigger: "blur"
    }]
  }
}

/**
 * 成果类型
 */
validateFormHandler.prototype.chiCateFormDataValidateRuls = function () {
  return {
    name: [{
      required: true,
      message: "请输入名称",
      trigger: "blur"
    }],
    type: [{
      required: true,
      message: "请选择类型",
      trigger: "blur"
    }]
  }
}

/**
 * 流程审批设置表单验证规则
 */
validateFormHandler.prototype.approvalProcessSettingFormDataValidateRuls = function () {
  return {
    processname: [{
      required: true,
      message: "请填写流程审批名称",
      trigger: "blur"
    }],
    processcategory: [{
      required: true,
      message: "请选择审批类型",
      trigger: "blur"
    }],
    basiccategoryinvoke: [{
      required: true,
      message: "请填写处理函数映射",
      trigger: "blur"
    }]
  }
}

/**
 * 人事考勤表单验证规则
 * 请假
 *applicationLeave: 1,
 *出差
 *businessTravel: 2,
 *外出
 *workOut: 3,
 *加班
 *overTime: 4,
 *调休
 *breakOff: 5  
 */
validateFormHandler.prototype.personnelWorkAttendanceRules = function (tag) {
  switch (tag) {
    case 1:
      return {
        startdistance: [{
          required: true,
          message: "请选择起始时间",
          trigger: "blur"
        }],
        reasons: [{
          required: true,
          message: "请填写请假事由",
          trigger: "blur"
        }],
        categorystring: [{
          required: true,
          message: "请选择请假类型",
          trigger: "blur"
        }],
        place: [{
          required: true,
          message: "请填写出差地点",
          trigger: "blur"
        }],
        breakoffdays: [{
          required: true,
          message: "请填写报销金额",
          trigger: "blur"
        }]
      }
  }
}

/**
 * 资产管理表单验证规则
 */
validateFormHandler.prototype.assetsFormDataValidateRules = function () {
  return {
    goodsname: [{
      required: true,
      message: "请填写物品名称",
      trigger: "blur"
    }],
    goodscode: [{
      required: true,
      message: "请填写物品编号",
      trigger: "blur"
    }],
    categoryname: [{
      required: true,
      message: "请选择物品类型",
      trigger: "blur"
    }],
    stock: [{
      required: true,
      message: "请填写库存量",
      trigger: "blur"
    }],
    fee: [{
      required: true,
      validator: this.validatorPrice,
      message: "请填写正确的价格",
      trigger: "blur"
    }]
  }
}

/**
 * 客户管理表单验证规则
 */
validateFormHandler.prototype.customerFormDataValidateRules = function () {
  return {
    cusname: [{
      required: true,
      message: "请填写客户名称",
      trigger: "blur"
    }],
    industrytype: [{
      required: true,
      message: "请选择客户性质",
      trigger: "blur"
    }],
    categoryname: [{
      required: true,
      message: "请选择行业类型",
      trigger: "blur"
    }],
    contactsusername: [{
      required: true,
      message: "请填写联系人",
      trigger: "blur"
    }],
    chargeusername: [{
      required: true,
      message: "请填写负责人",
      trigger: "blur"
    }],
    scale: [{
      required: true,
      message: "请选择客户规模",
      trigger: "blur"
    }],
    phone: [{
      required: true,
      message: "请填写手机",
      trigger: "blur"
    }],
    status: [{
      required: true,
      message: "请选择客户状态",
      trigger: "blur"
    }],
    resource: [{
      required: true,
      message: "请选择来源",
      trigger: "blur"
    }],
    provice: [{
      required: true,
      message: "请选择省",
      trigger: "blur"
    }],
    city: [{
      required: true,
      message: "请选择市",
      trigger: "blur"
    }],
    area: [{
      required: true,
      message: "请选择区",
      trigger: "blur"
    }],
    isvip: [{
      required: true,
      message: "请选择客户类型",
      trigger: "blur"
    }],
    viplastdate: [{
      required: true,
      message: "请选择vip到期时间",
      trigger: "blur"
    }]
  }
}

/**
 * 客户跟进管理表单验证规则
 */
validateFormHandler.prototype.customerFollowFormDataValidateRules = function () {
  return {
    cusid: [{
      required: true,
      message: "请选择跟进客户",
      trigger: "blur"
    }],
    followcategory: [{
      required: true,
      message: "请选择跟进方式",
      trigger: "blur"
    }],
    followcontent: [{
      required: true,
      message: "请填写跟进内容",
      trigger: "blur"
    }],
    followdate: [{
      required: true,
      message: "请选择跟进时间",
      trigger: "blur"
    }]
  }
}

/**
 * 合同管理表单验证规则
 */
validateFormHandler.prototype.contractFormDataValidateRules = function () {
  return {
    contractcode: [{
      required: true,
      message: "请填写合同编号",
      trigger: "blur"
    }],
    contractname: [{
      required: true,
      message: "请填写合同名称",
      trigger: "blur"
    }],
    cusid: [{
      required: true,
      message: "请选择客户",
      trigger: "blur"
    }],
    userid: [{
      required: true,
      message: "请选择负责人",
      trigger: "blur"
    }],
    fee: [{
      required: true,
      message: "请填写合同金额",
      trigger: "blur"
    }],
    signdate: [{
      required: true,
      message: "请填写合同签订时间",
      trigger: "blur"
    }],
    startdate: [{
      required: true,
      message: "请填写合同开始时间",
      trigger: "blur"
    }],
    enddate: [{
      required: true,
      message: "请填写合同截止时间",
      trigger: "blur"
    }]
  }
}

/**
 * 添加项目表单验证规则
 */
validateFormHandler.prototype.projectFormDataValidateRuls = function () {
  return {
    title: [{
      required: true,
      message: "请填写标题",
      trigger: "blur"
    }],
    content: [{
      required: true,
      message: "请上传内容",
      trigger: "blur"
    }],
    category: [{
      required: true,
      message: "请选择类型",
      trigger: "blur"
    }],
  }
}

/**
 * 添加项目bug表单验证规则
 */
validateFormHandler.prototype.projectBugFormDataValidateRule = function () {
  return {
    projectid: [{
      required: true,
      message: "请选择所属项目",
      trigger: "blur"
    }],
    stepanalysisid: [{
      required: true,
      message: "请选择所属模块",
      trigger: "blur"
    }],
    title: [{
      required: true,
      message: "请填写bug描述",
      trigger: "blur"
    }],
    level: [{
      required: true,
      message: "请选择严重等级",
      trigger: "blur"
    }],
    priority: [{
      required: true,
      message: "请选择处理优先级",
      trigger: "blur"
    }]
  }
}

/**
 * 添加工单任务表单验证规则
 */
validateFormHandler.prototype.projectTaskFormDataValidateRule = function () {
  return {
    projectid: [{
      required: true,
      message: "请选择所属项目",
      trigger: "blur"
    }],
    tasktitle: [{
      required: true,
      message: "请填写bug描述",
      trigger: "blur"
    }],
    assignusers: [{
      required: true,
      message: "请选择指派人员",
      trigger: "blur"
    }]
  }
}

/**
 * 任务拆分表单验证规则
 */
validateFormHandler.prototype.assignnewFormDataValidateRuls = function () {
  return {
    title: [{
      required: true,
      message: "请输入模块标题",
      trigger: "blur"
    }],
    completedate: [{
      required: true,
      message: "请选择最迟完成时间",
      trigger: "blur"
    }],
    completeallhour: [{
      required: true,
      message: "请输入最长完成工时",
      trigger: "blur"
    }]
  }
}

/**
 * 添加报告表单验证规则
 */
validateFormHandler.prototype.supplierFormDataValidateRuls = function () {
  return {
    supname: [{
      required: true,
      message: "供应商名称",
      trigger: "blur"
    }],
    address: [{
      required: true,
      message: "供应商地址",
      trigger: "blur"
    }]
  }
}

/**
 * 添加产品类型表单验证规则
 */
validateFormHandler.prototype.goodsCategoryFormDataValidateRuls = function () {
  return {
    categoryname: [{
      required: true,
      message: "类型名称",
      trigger: "blur"
    }],
    sort: [{
      required: true,
      message: "排序",
      trigger: "blur"
    }]
  }
}

/**
 * 广告表单验证规则
 */
validateFormHandler.prototype.adFormDataValidateRuls = function () {
  return {
    title: [{
      required: true,
      message: "请输入广告标题",
      trigger: "blur"
    }],
    thumb: [{
      required: true,
      message: "请上传广告图片",
      trigger: "blur"
    }],
    pricemonth: [{
      required: true,
      message: "请输入月度价格",
      trigger: "blur"
    }],
    priceyear: [{
      required: true,
      message: "请输入年度价格",
      trigger: "blur"
    }]
  }
}

/**
 * 添加充值方案表单验证规则
 */
validateFormHandler.prototype.chongzhiCaseFormDataValidateRuls = function () {
  return {
    casename: [{
      required: true,
      message: "请输入方案名称",
      trigger: "blur"
    }],
    price: [{
      required: true,
      message: "请输入方案价格",
      trigger: "blur"
    }],
    jifen: [{
      required: true,
      message: "请输入方案积分",
      trigger: "blur"
    }],
    jianglijifen: [{
      required: true,
      message: "请输入奖励积分",
      trigger: "blur"
    }]
  }
}

/**
 * 门店银行卡绑定表单验证规则
 */
validateFormHandler.prototype.storeBindBankAccountValidateRuls = function () {
  return {
    realname: [{
      required: true,
      message: "请输入真实姓名",
      trigger: "blur"
    }],
    idcard: [{
      required: true,
      message: "请输入身份证号码",
      trigger: "blur"
    }],
    bankcardno: [{
      required: true,
      message: "请输入正确的银行卡号",
      trigger: "blur"
    }],
    bankcardphone: [{
      required: true,
      message: "请输入开户银行预留手机",
      trigger: "blur"
    }],
    bankid: [{
      required: true,
      message: "请输入开户行总行联行号",
      trigger: "blur"
    }],
    bankkey: [{
      required: true,
      message: "请输入开户行支行联行号",
      trigger: "blur"
    }],
    bankname: [{
      required: true,
      message: "请输入开户银行名称",
      trigger: "blur"
    }],
    subbankname: [{
      required: true,
      message: "请输入开户支行名称",
      trigger: "blur"
    }]
  }
}

/**
 * 门店类型表单验证规则
 */
validateFormHandler.prototype.storeFormDataValidateRuls = function () {
  return {
    sname: [{
      required: true,
      message: "门店名称",
      trigger: "blur"
    }],
    sheng: [{
      required: true,
      message: "请输入省份",
      trigger: "blur"
    }],
    shi: [{
      required: true,
      message: "请选择城市",
      trigger: "blur"
    }],
    qu: [{
      required: true,
      message: "请选择区域",
      trigger: "blur"
    }],
    lng: [{
      required: true,
      message: "请输入经度",
      trigger: "blur"
    }],
    lat: [{
      required: true,
      message: "请输入纬度",
      trigger: "blur"
    }],
    phone: [{
      required: true,
      message: "请输入手机号",
      trigger: "blur"
    }]
  }
}
/**
 * 添加产品表单验证规则
 */
validateFormHandler.prototype.goodsFormDataValidateRuls = function () {
  return {
    supid: [{
      required: true,
      message: "请选择供应商",
      trigger: "blur"
    }],
    categoryid: [{
      required: true,
      message: "请选择产品类型",
      trigger: "blur"
    }],
    goodsname: [{
      required: true,
      message: "请输入产品名称",
      trigger: "blur"
    }],
    price: [{
      required: true,
      message: "请输入产品价格",
      trigger: "blur"
    }],
    jifen: [{
      required: true,
      message: "请输入兑换积分",
      trigger: "blur"
    }]
  }
}

/**
 * 添加C端产品表单验证规则
 */
validateFormHandler.prototype.cusGoodsFormDataValidateRuls = function () {
  return {
    goodsname: [{
      required: true,
      message: "请输入产品名称",
      trigger: "blur"
    }],
    price: [{
      required: true,
      message: "请输入产品价格",
      trigger: "blur"
    }],
    vipprice: [{
      required: true,
      message: "请输入会员价",
      trigger: "blur"
    }],
    jifen: [{
      required: true,
      message: "请输入兑换积分",
      trigger: "blur"
    }],
    kucun: [{
      required: true,
      message: "请输入库存",
      trigger: "blur"
    }]
  }
}

/**
 * vip卡卷表单验证规则
 */
validateFormHandler.prototype.vipCategoryFormDataValidateRuls = function () {
  return {
    cardcategoryname: [{
      required: true,
      message: "请输入卡卷名称",
      trigger: "blur"
    }],
    zhekou: [{
      required: true,
      message: "折扣范围0-1之间",
      validator: this.validateZhekou,
      trigger: "blur"
    }],
    price: [{
      required: true,
      message: "请输入价格",
      trigger: "blur"
    }],
    shareprice: [{
      required: true,
      message: "请输入分享奖励金额",
      trigger: "blur"
    }]
  }
}

/**
 * 加油退款表单验证规则
 */
validateFormHandler.prototype.gasOrderRefundFormDataValidateRuls = function () {
  return {
    refundAmount: [{
      required: true,
      message: "请输入退款金额",
      trigger: "blur"
    }],
    remark: [{
      required: true,
      message: "请输入退款备注",
      trigger: "blur"
    }]
  }
}
export default validateFormHandler;



// WEBPACK FOOTER //
// ./src/helper/formvalidate.js